import { render, staticRenderFns } from "./appraisalNoBindQuestionBankList.vue?vue&type=template&id=507a5a20"
import script from "./appraisalNoBindQuestionBankList.vue?vue&type=script&lang=js"
export * from "./appraisalNoBindQuestionBankList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports